var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongPaizhao(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 4.481a.5.5 0 01.5-.5h1.425a.2.2 0 00.181-.116l.416-.9A.8.8 0 014.75 2.5h2.74a.8.8 0 01.726.464l.416.9a.2.2 0 00.181.117H14a.5.5 0 01.5.5V13a.5.5 0 01-.5.5H2a.5.5 0 01-.5-.5V4.481z",
    stroke: "#3F465C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.5,
    r: 2.5,
    stroke: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.959 6.042h-1.334",
    stroke: "#3F465C",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_paizhao.700d6115.svg";
export { SvgTongyongPaizhao as ReactComponent };